import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Image from 'common/image'

const BoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 359px;
    padding: 32px 20px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 56px;
`

const TitleText = styled.div`
    color: var(--Brand-Color-Black, #121b21);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px; /* 125% */
`

const TitleUnderLine = styled.div`
    margin-top: 16px;
    width: 59px;
    height: 5px;
    background: #d9c277;
`

const ContentText = styled.div`
    margin-top: 16px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
`

const FirstLineRow = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: row;
`

const FirstLineText = styled.div`
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 111.111% */
`

const SecondLineText = styled.div`
    padding-top: 24px;
    color: #4e3821;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 125% */
`

export default function AboutProgramme() {
    const { t } = useTranslation('', {
        keyPrefix: 'priorityprogramme.aboutprogrammewidget',
    })
    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`title`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <Image
                src={t(`image`)}
                width={318}
                height={212}
                style={{
                    borderRadius: '25px',
                    marginTop: '32px',
                    marginBottom: '32px',
                }}
                alt="About priority programme banner"
            />
            <ContentText>{t(`content1`)}</ContentText>
            <ContentText>{t(`content2`)}</ContentText>
            <ContentText>{t(`content3`)}</ContentText>
            <FirstLineRow>
                <FirstLineText>{t(`subtitle`)}</FirstLineText>
            </FirstLineRow>
            <SecondLineText>{t(`subcontent1`)}</SecondLineText>
            <SecondLineText>{t(`subcontent2`)}</SecondLineText>
        </BoxContainer>
    )
}
